import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { ValidateQRCode } from '../../Backend/ApiCalls';
import './QRValidationComponent.css';

const AGE_LABEL = { 0: 'Exento', 1: 'Infantil', 2: 'Juvenil', 3: 'Adulto' };
const formatDate = (value) => value ? new Date(`${value}T00:00:00`).toLocaleDateString('es-ES') : null;

function QRValidationComponent() {
  const token = new URLSearchParams(useLocation().search).get('token');
  const [result, setResult] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!token) { setError('QR no válido'); return; }
    ValidateQRCode(token).then(({ response, data }) => {
      if (!response.ok || !data?.verified) throw new Error(data?.error || 'No se ha podido verificar');
      setResult(data);
    }).catch((err) => setError(err.message));
  }, [token]);

  if (error) return <main className="qr-user-info-container qr-invalid"><h1>No se ha podido verificar</h1><p className="error">{error}</p></main>;
  if (!result) return <main className="qr-user-info-container"><p className="loading">Validando el QR…</p></main>;

  const { member, promotion } = result;
  return (
    <main className="qr-user-info-container qr-valid">
      <p className="qr-brand">Falla Plaza Rodrigo</p>
      <h1>✓ Fallero verificado</h1>
      <h2>{member.name} {member.surname}</h2>
      <p>{AGE_LABEL[member.ageType] || 'Fallero'}</p>
      <p>Pertenece actualmente a Falla Plaza Rodrigo.</p>
      <hr />
      <h2>✓ Descuento disponible</h2>
      <p><strong>{promotion.name}</strong> · {promotion.title}</p>
      {(promotion.startDate || promotion.endDate) && <p>Promoción válida: {formatDate(promotion.startDate) || 'actual'} – {formatDate(promotion.endDate) || 'sin fecha fin'}</p>}
      {promotion.conditions && <p><strong>Condiciones:</strong> {promotion.conditions}</p>}
      <p className="qr-privacy-note">Este QR acredita la pertenencia a Falla Plaza Rodrigo. No muestra DNI, teléfono ni correo.</p>
    </main>
  );
}

export default QRValidationComponent;
